<template>
  <van-row justify="center" class="page-wrapper">
    <!-- Скелетон в виде счетчика -->
    <div v-if="isLoadingStatus" class="skeleton-counter-wrapper">
      <div class="skeleton-counter">
        <div class="skeleton-counter-display">
          <div class="skeleton-digit" v-for="n in 6" :key="n"></div>
        </div>
        <div class="skeleton-counter-title"></div>
        <div class="skeleton-counter-info"></div>
      </div>
    </div>

    <!-- ✅ Основной контент страницы (показывается после проверки) -->
    <van-col v-else span="24" class="full-width-col">
      <template v-if="meterageZone !== null">
        <div class="send-indications-content">
          <div class="place-content-center">
            <div class="info-block">
              <h5 class="info-title">
                {{ $t("regionalEnergy.sendIndications.counterTitle") }}
              </h5>
              <div class="info-row">
                <span>{{
                  $t("regionalEnergy.sendIndications.accountNumber")
                }}</span>
                <span>{{ accountNumber }}</span>
              </div>
              <div class="info-row">
                <span>{{
                  $t("regionalEnergy.sendIndications.lastIndicationsDate")
                }}</span>
                <span>{{ lastIndicationDate }}</span>
              </div>
            </div>
            <flashlight />
            <template v-if="meterageZone === 1">
              <template v-if="windowWidth >= 340">
                <single-zone-standart :initial-form-step="formStep" />
              </template>
              <template v-else>
                <single-zone-small :initial-form-step="formStep" />
              </template>
            </template>
            <template v-else>
              <template v-if="windowWidth >= 340">
                <multi-zone-standart :initial-form-step="formStep" />
              </template>
              <template v-else>
                <multi-zone-small :initial-form-step="formStep" />
              </template>
            </template>
          </div>
        </div>
      </template>
    </van-col>
  </van-row>
</template>

<script>
import "vue-awesome/icons/history";
import "vue-awesome/icons/paper-plane";
import SingleZoneStandart from "@/components/indications/SingleZoneStandart";
import MultiZoneStandart from "@/components/indications/MultiZoneStandart";
import Flashlight from "@/components/indications/Flashlight";
import SingleZoneSmall from "@/components/indications/SingleZoneSmall";
import MultiZoneSmall from "@/components/indications/MultiZoneSmall";
import axios from "axios";

// Создаем настроенный клиент, который берет URL из .env файла
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_NEW_API_URL,
  timeout: 120000,
});

export default {
  name: "SendIndications",
  components: {
    MultiZoneSmall,
    SingleZoneSmall,
    Flashlight,
    MultiZoneStandart,
    SingleZoneStandart,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      isLoadingStatus: true,
      formStep: 1,
    };
  },
  computed: {
    photoMode: {
      get() {
        return this.$store.state.RegionalEnergy.sendPhoto;
      },
      set(photoMode) {
        this.$store.commit("RegionalEnergy/SET_PHOTO_MODE", photoMode);
      },
    },
    meterageZone() {
      return this.$store.state.RegionalEnergy.meterage_zone || 1;
    },
    indicationsHistory() {
      return this.$store.state.IndicationsHistory.indicationsHistory;
    },
    errorMessage() {
      return this.$store.state.Api.errors.message;
    },
    accountNumber() {
      return this.$route.params.account;
    },
    lastIndicationDate() {
      const history = this.$store.state.IndicationsHistory.indicationsHistory;
      if (history && history.length > 0) {
        return history[0].date;
      }
      return "...";
    },
  },
  watch: {
    indicationsHistory(newValue) {
      if (newValue && newValue.length > 0) {
        this.$store.commit(
          "RegionalEnergy/UPDATE_LAST_INDICATOR_SVALUE1",
          newValue[0].value
        );
      }
    },
    formStep(newValue) {
      console.log("SendIndications: formStep changed to", newValue);
    },
  },
  mounted() {
    this.checkUserStatus();
  },
  created() {
    if (this.indicationsHistory && this.indicationsHistory.length > 0) {
      this.$store.commit(
        "RegionalEnergy/UPDATE_LAST_INDICATOR_SVALUE1",
        this.indicationsHistory[0].value
      );
    } else {
      // Передаем accountId для получения истории показаний по конкретному счету
      this.$store.dispatch("IndicationsHistory/getAllIndicationsHistory", {
        accountId: this.accountNumber,
      });
    }
    window.addEventListener("resize", this.changeWidthOfWindow);
  },
  destroyed() {
    window.removeEventListener("resize", this.changeWidthOfWindow);
  },
  methods: {
    async checkUserStatus() {
      this.isLoadingStatus = true;

      // Приоритет использования учетных данных:
      // 1. Сохраненные данные для показаний из localStorage
      // 2. Данные из основной авторизации
      const savedUsername = localStorage.getItem("savedUsername");
      const savedPassword = localStorage.getItem("savedPassword");
      let credentials;

      if (savedUsername && savedPassword) {
        console.log(
          "DEBUG: Используем сохраненные учетные данные для показаний"
        );
        credentials = {
          username: savedUsername,
          password: savedPassword,
        };
      } else {
        // Если нет сохраненных данных, используем данные из основной авторизации
        credentials = this.$store.state.Auth.userCredentials;
      }

      console.log(
        "DEBUG: Проверка учетных данных в SendIndications:",
        JSON.stringify(credentials, null, 2)
      );

      if (!credentials || !credentials.username || !credentials.password) {
        console.log("DEBUG: Учетные данные отсутствуют, переходим к шагу 3");
        this.formStep = 3; // Если данных для входа нет, сразу показываем форму первого входа
        this.isLoadingStatus = false;
        return;
      }

      try {
        const { username, password } = credentials;
        const response = await apiClient.post("send_meter", {
          username,
          password,
          account_id: this.accountNumber,
          reading: "0",
        });

        console.log("API Response:", response.data);

        const errorMessage = response.data?.message || "";

        // Проверяем на сообщение "Рахунок знайдено. Показання не передані."
        // Это означает, что аккаунт найден и нужно показать форму отправки показаний
        if (errorMessage.includes("Рахунок знайдено")) {
          console.log(
            "DEBUG: Account found, showing indications form (formStep 1)"
          );
          this.formStep = 1; // Аккаунт найден, показываем форму передачи показаний
        }
        // Проверяем на ошибку "Логін або пароль вказано не вірно"
        // Это означает неверные учетные данные - показываем форму входа
        else if (errorMessage.includes("Логін або пароль")) {
          console.log(
            "DEBUG: Invalid credentials, showing login form (formStep 4)"
          );
          this.formStep = 4; // Неверный логин/пароль, показываем форму повторного входа
        }
        // Для обратной совместимости - если статус "contract_exists"
        else if (response.data && response.data.status === "contract_exists") {
          console.log(
            "DEBUG: Contract exists, showing indications form (formStep 1)"
          );
          this.formStep = 1;
        } else {
          console.log(
            "DEBUG: Default case - showing indications form (formStep 1)"
          );
          this.formStep = 1;
        }
      } catch (error) {
        console.error(
          "API Error:",
          error.response?.status,
          error.response?.data
        );

        const errorMessage = error.response?.data?.message || "";
        const errorDetail = error.response?.data?.detail || "";

        if (errorMessage.includes("no_contract")) {
          this.formStep = 1;
        } else if (errorMessage.includes("Waiting for selector")) {
          this.formStep = 4;
        } else if (
          error.response &&
          error.response.status === 500 &&
          errorDetail.includes("Не найдена вкладка 'Показання лічильника'")
        ) {
          console.log(
            "DEBUG: Обнаружена ошибка 500 с сообщением о ненайденной вкладке - переключаемся на formStep = 4"
          );
          this.formStep = 4;
        } else if (
          error.response &&
          error.response.status === 500 &&
          error.response.data &&
          error.response.data.detail === "Невірний логін або пароль"
        ) {
          console.log(
            "DEBUG: Обнаружена ошибка 500 с сообщением о неверном логине/пароле - переключаемся на formStep = 4"
          );
          this.formStep = 4;
          return;
        } else if (
          error.response &&
          error.response.status === 401 &&
          error.response.data &&
          error.response.data.detail === "невірний логін або пароль"
        ) {
          console.log(
            "DEBUG: Обнаружена ошибка 401 с сообщением о неверном логине/пароле - переключаемся на formStep = 4"
          );
          this.formStep = 4;
          return;
        } else if (error.response && error.response.status === 500) {
          console.log("DEBUG: Принудительный переход на шаг 4 при ошибке 500");
          this.formStep = 4;
        } else {
          this.formStep = 1;
        }
        console.log("DEBUG: Обработка ошибки в SendIndications:", {
          errorMessage,
          status: error.response?.status,
        });
        console.log("DEBUG: Полный объект ошибки:", error);
        console.log("DEBUG: Полный объект response:", error.response);
        console.log("DEBUG: Полный объект data:", error.response?.data);
        console.log(
          "DEBUG: Полный объект detail:",
          error.response?.data?.detail
        );
      } finally {
        this.isLoadingStatus = false;

        // Загружаем историю показаний для конкретного счета
        if (this.formStep === 1) {
          this.$store.dispatch("IndicationsHistory/getAllIndicationsHistory", {
            accountId: this.accountNumber,
          });
        }
      }
    },
    switchMode() {
      this.$store.commit("RegionalEnergy/SET_PHOTO_MODE");
    },
    changeWidthOfWindow() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style scoped>
/* ✅ Стили для полноэкранного загрузчика */
.loading-fullscreen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80vh;
  color: #ecf0f1;
}
.loading-fullscreen p {
  margin-top: 15px;
}

/* Стили для скелетона-счетчика */
.skeleton-counter-wrapper {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
}

.skeleton-counter {
  background: #0e121c;
  border-radius: 16px;
  padding: 25px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 280px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

.skeleton-counter-display {
  background: #1a1f2c;
  border-radius: 8px;
  padding: 15px;
  display: flex;
  justify-content: center;
  gap: 5px;
  border: 1px solid #2a2f3c;
}

.skeleton-digit {
  width: 30px;
  height: 45px;
  border-radius: 4px;
  background: linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-counter-title {
  height: 20px;
  width: 70%;
  margin: 0 auto;
  border-radius: 4px;
  background: linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-counter-info {
  height: 16px;
  width: 90%;
  margin: 0 auto;
  border-radius: 4px;
  background: linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.page-wrapper {
  min-height: 100vh;
  display: flex; /* Добавляем flex для управления дочерними элементами */
  flex-direction: column;
}

.send-indications-content {
  flex-grow: 1; /* Разрешаем блоку занимать все доступное пространство */
  overflow-y: auto; /* Добавляем скролл, если контент не помещается */
  padding: 15px;
}
</style>
<style scoped>
.full-width-col {
  display: flex;
  justify-content: center;
}

@import "../../../../node_modules/vant/lib/dialog/index.css";
@import "../../../../node_modules/vant/lib/overlay/index.css";
@import "../../../../node_modules/vant/lib/popup/index.css";
@import "../../../../node_modules/vant/lib/switch/index.css";

.info-block {
  background-color: #0e121c;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  color: #ecf0f1;
}

.info-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  text-align: center;
  color: #ecf0f1;
}

.info-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  margin-bottom: 8px;
}

.info-row span:first-child {
  color: rgb(255, 255, 255);
}

.count-zones {
  display: inline-block;
  border: 1px solid #c4c4c4;
  padding: 5px 28px 5px 28px;
  border-radius: 5px;
}
h5 {
  color: #0b0b0b;
  padding: 0;
  text-align: center;
  font-size: 18px;
  margin: 0;
}

:deep(.send-indications-table th) {
  color: #4277f5;
}

:deep(.send-indications-table .prev-ind-wrapper) {
  color: rgb(255, 255, 255);
  font-size: 18px;
  font-weight: bold;
  padding-top: 10px;
}
.loading-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 20vh auto;
  text-align: center;
}
.loading-text {
  color: #bdc3c7;
  margin-top: 15px;
  font-size: 16px;
}
.loading-fullscreen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.8);
  text-align: center;
  color: #ecf0f1;
}
</style>
